import { render, staticRenderFns } from "./AbsenceTypeEditForm.vue?vue&type=template&id=f6b89a90"
import script from "./AbsenceTypeEditForm.vue?vue&type=script&lang=js"
export * from "./AbsenceTypeEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports